
import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';

export const NotFoundPage: React.FC = () => {
    return (
        <div className="relative w-full min-h-screen bg-zinc-950 flex flex-col items-center justify-center p-4 overflow-hidden">
            {/* Ambient Glow Background */}
            <div className="absolute inset-0 bg-gradient-to-t from-zinc-950 via-zinc-900/50 to-zinc-950 pointer-events-none" />

            {/* Cinema Screen Container */}
            <motion.div
                className="relative z-10 w-full max-w-3xl aspect-video bg-black rounded-sm shadow-[0_0_100px_rgba(255,255,255,0.1)] overflow-hidden border-t-2 border-zinc-800/30"
                initial={{ opacity: 0, scale: 0.95 }}
                animate={{ opacity: 1, scale: 1 }}
                transition={{ duration: 1.2, ease: "easeOut" }}
            >
                {/* The Projected Image */}
                <img
                    src="/01-WebsiteFiles/404Error/Tired-D-Command.webp"
                    alt="Tired D-Command Console"
                    className="w-full h-full object-cover opacity-90"
                />

                {/* Screen Texture/Grain Overlay */}
                <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/stardust.png')] opacity-20 mix-blend-overlay pointer-events-none" />

                {/* Vignette for projection look */}
                <div className="absolute inset-0 bg-[radial-gradient(circle,transparent_50%,rgba(0,0,0,0.8)_100%)] pointer-events-none" />
            </motion.div>

            {/* Content / Title Card */}
            <div className="relative z-20 mt-12 text-center">
                <motion.h1
                    className="text-4xl md:text-6xl font-bold text-gray-100 tracking-wider font-serif drop-shadow-lg"
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 1, delay: 0.5 }}
                >
                    Shh....
                </motion.h1>

                <motion.p
                    className="text-xl md:text-2xl text-gray-400 font-light mt-2 tracking-wide uppercase"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ duration: 1, delay: 0.8 }}
                >
                    page not found!
                </motion.p>

                <motion.div
                    className="mt-8"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ duration: 1, delay: 1.2 }}
                >
                    <Link
                        to="/"
                        className="group inline-flex items-center gap-2 px-6 py-2 text-sm text-gray-400 hover:text-white transition-colors duration-300"
                    >
                        <span className="group-hover:-translate-x-1 transition-transform duration-300">←</span>
                        <span>Return to Studio</span>
                    </Link>
                </motion.div>
            </div>
        </div>
    );
};

export default NotFoundPage;
